import {useMemo} from "react";


export const useGeneratedId = (name: string) => {
    return useMemo(() => `form_id__${name}`, [name])
}